;(function () {
  angular
    .module('contrast.thermometer-filter')
    .directive('csThermometerFilter', [csThermometerFilter])

  function csThermometerFilter() {
    return {
      restrict: 'EA',
      bindToController: {
        filterTestSuffix: '=?',
        filterName: '=?',
        filterRemaining: '=?',
        filterSubtext: '=?',
        filterPercent: '=?',
        filterData: '=?',
        filterMax: '=?',
        filterDisabled: '=?',
        filterClassAccessor: '&?',
        filterNameFunction: '&?',
        filterClickHandler: '&?'
      },
      templateUrl: 'views/common/cs-thermometer-filter.html',
      controller: csThermometerFilterCtrl,
      controllerAs: 'filterCtrl',
      link: link
    }

    function link(scope, element, attrs, controller) {
      if (!controller.filterMax) {
        controller.filterMax = 100
      }
    }

    function csThermometerFilterCtrl() {}
  }
})()
